export const selectWalletAggregation = (state) => state.walletAggregation;
export const selectWalletAggregationLoading = (state) => state.walletAggregationLoading;
export const selectTransactionAggregation = (state) => state.transactionAggregation;
export const selectTransactionAggregationLoading = (state) => state.transactionAggregationLoading;
const selectAggregations = (state) => state.aggregations;
export const selectAggregationsData = (state) => selectAggregations(state).data;
export const selectAggregationsTotal = (state) => selectAggregations(state).total;
export const selectMixedTransaction = (state) => state.mixedTransaction;
export const selectMixedTransactionLoading = (state) => state.mixedTransactionLoading;
